import Chart from "chart.js/auto";
import ChartControllerBase from "./chart_controller_base";

// Ranked bars for a categorical field's options, switchable between counting
// states and counting lives. Chart data (from
// PayerProfile::CategoricalBreakdown#bar_chart_data):
//   { options: [{ label, color, states, lives }] }
export default class extends ChartControllerBase {
  static targets = ["canvas"];

  connect() {
    this.params = JSON.parse(this.data.get("chartData"));
    this.measure = "states";
    this.chart = this.renderChart();
  }

  disconnect() {
    this.chart?.destroy();
  }

  // The controller wraps the toggle as well as the chart, so the canvas goes
  // into the sized element rather than the wrapper.
  appendCanvas() {
    const canvas = document.createElement("canvas");

    this.canvasTarget.appendChild(canvas);

    return canvas;
  }

  switchMeasure(event) {
    this.measure = event.currentTarget.dataset.measure;

    this.element.querySelectorAll("[data-measure]").forEach(button => {
      const selected = button.dataset.measure === this.measure;

      button.classList.toggle("bg-indigo", selected);
      button.classList.toggle("text-white", selected);
      button.classList.toggle("text-gray-600", !selected);
    });

    // Reordering has to carry each option's color with it, or the bars keep
    // the colors of whichever options previously held those positions.
    const sorted = this.sorted;

    this.chart.data.labels = sorted.map(option => option.label);
    this.chart.data.datasets[0].data = sorted.map(option => option[this.measure]);
    this.chart.data.datasets[0].backgroundColor = sorted.map(option => option.color);
    this.chart.options.scales.x.title.text = this.axisTitle;
    this.chart.update();

    // payer_profile_option_states_controller orders its state lists to match
    this.element.dispatchEvent(
      new CustomEvent("payer-profile-measure-changed", {
        bubbles: true,
        detail: { measure: this.measure },
      }),
    );
  }

  get axisTitle() {
    return this.measure === "lives" ? "Lives" : "States";
  }

  // Bubbles up to payer_profile_option_states_controller, which opens the
  // list of states behind the clicked bar
  selectOption(elements) {
    if (!elements.length) return;

    const option = this.sorted[elements[0].index];

    this.element.dispatchEvent(
      new CustomEvent("payer-profile-option-selected", {
        bubbles: true,
        detail: { key: option.key },
      }),
    );
  }

  get sorted() {
    return [...this.params.options].sort((a, b) => b[this.measure] - a[this.measure]);
  }

  renderChart() {
    const sorted = this.sorted;

    return new Chart(this.appendCanvas(), {
      type: "bar",
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        onClick: (event, elements) => this.selectOption(elements),
        onHover: (event, elements) => {
          event.native.target.style.cursor = elements.length ? "pointer" : "";
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: { precision: 0 },
            title: { display: true, text: this.axisTitle },
          },
        },
      },
      data: {
        labels: sorted.map(option => option.label),
        datasets: [
          {
            data: sorted.map(option => option[this.measure]),
            backgroundColor: sorted.map(option => option.color),
          },
        ],
      },
    });
  }
}
